const NotFound = () => {
  return (
    <div className="grid h-screen place-content-center bg-white px-4 dark:bg-black">
      <h1 className="uppercase tracking-widest text-black dark:text-white">
        404 | Not Found
      </h1>
    </div>
  );
};

export default NotFound;
